module.exports = __webpack_public_path__ + "img/icon_reset_round.182a290.svg";